import React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  setStep,
  toggleModal,
  updateGuestBanner
} from '@store/user-review/actions';
import Icon from '@components/shared/Icon';
import Text from '@components/shared/Text';
import { reviewSteps } from '@constants/review';
import Hotjar from '@utils/Hotjar';
import hjEvents from '@constants/hj-events';

const CardProtect = ({
  text,
  setStep,
  toggleModal,
  className,
  updateGuestBanner,
  guestRedirectUri
}) => (
  <div
    className={classNames('review-card-protect', className)}
    onClick={() => {
      if (guestRedirectUri) {
        updateGuestBanner({ redirectUri: guestRedirectUri });
      }
      Hotjar.vpv(hjEvents.hiddenReviewRegistrationModal);
      setStep(reviewSteps.guestBanner);
      toggleModal();
    }}
  >
    <div className="review-card-protect__blob">
      <Icon icon="lock" className="review-card-protect__icon" />
    </div>
    <Text className="review-card-protect__text">{text}</Text>
  </div>
);

CardProtect.defaultProps = {
  text: 'Join the CureRate community to see reviews from people like you'
};

CardProtect.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  setStep: PropTypes.func,
  toggleModal: PropTypes.func,
  updateGuestBanner: PropTypes.func,
  guestRedirectUri: PropTypes.string
};

export default connect(null, { setStep, toggleModal, updateGuestBanner })(
  CardProtect
);
